import DatePicker from "react-datepicker";
import styles from "./DatePicker.module.scss";
import { CalenderIcon } from "../../../../assets/icons/svgicons";

const CommonDatePicker = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  placeholder,
  minDate,
  maxDate,
  className,
  variant,
  formik,
  showMonthYearPicker = false
}) => {
  return (
    <div className={`${styles.datePickerWrapper} ${className || ""}`} data-variant={variant}>
      {label && <label className={styles.label}>{label}</label>}
      <DatePicker
        selected={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholderText={placeholder}
        minDate={minDate}
        maxDate={maxDate}
        className={styles.input}
        formik={formik}
        name={name}
        dateFormat="dd/MM/yyyy"
        showIcon
        icon={<CalenderIcon />}
        showMonthYearPicker={showMonthYearPicker}
      />

      {formik.touched[name] && formik.errors[name] && (
        <p className={styles.error}>{formik.errors[name]}</p>
      )}
    </div>
  );
};

export default CommonDatePicker;
